import { render, staticRenderFns } from "./SpreadsheetItem.vue?vue&type=template&id=7d65d526&scoped=true&"
import script from "./SpreadsheetItem.vue?vue&type=script&lang=ts&"
export * from "./SpreadsheetItem.vue?vue&type=script&lang=ts&"
import style0 from "./SpreadsheetItem.vue?vue&type=style&index=0&id=7d65d526&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d65d526",
  null
  
)

export default component.exports